import { render, staticRenderFns } from "./rodape-impressao.vue?vue&type=template&id=36c24e6d&scoped=true"
import script from "./rodape-impressao.vue?vue&type=script&lang=js"
export * from "./rodape-impressao.vue?vue&type=script&lang=js"
import style0 from "./rodape-impressao.vue?vue&type=style&index=0&id=36c24e6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c24e6d",
  null
  
)

export default component.exports